
import img1 from '../images/template1.PNG'
import img2 from '../images/template2.PNG'
import img3 from '../images/template3.PNG'
import img4 from '../images/template4.PNG'

const Templates= [
{
    id: 1,
    img: img1,
    name:'Template 1'
},
{
    id: 2,
    img: img2,
    name:'Template 2'
},
{
    id: 3,
    img: img3,
    name:'Template 3'
},
{
    id: 4,
    img: img4,
    name:'Template 4'
}
]

export default Templates;